import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

@Component({
    selector: 'command-properties',
    template: require('./command-properties.component.html'),
    styles: [require('./command-properties.component.scss')]
})
export class CommandPropertiesComponent {
    @Input() public item: any;
    @Output() public onGenerateScript = new EventEmitter<any>();

    @ViewChild('command') public command: ElementRef;

    public copy() {
        this.command.nativeElement.select();
        try {
            const successful = document.execCommand('copy');
            if (!successful) {
                throw successful;
            }
        } catch (err) {
            window.prompt('Copy to clipboard: Ctrl+C, Enter', this.item.commandLineScript);
        }
    }

    public getData(field: any) {
        if (field.dependedOn == null) {
            return field.optionValues[0].data;
        }
        const dataProvider = this.item.selectedCommandFields.filter((x: any) => x.order == field.dependedOn)[0];
        const correctValue = field.optionValues.filter((x: any) => x.key == dataProvider.value)[0];
        if (correctValue == null) {
            return [];
        }
        if (!correctValue.data.some((x: any) => x == field.value)) {
            field.value = correctValue.data[0];
        }
        return correctValue.data;
    }

    public getName() {
        return this.item.name.replace(/([A-Z]+)/g, ' $1');
    }

    public hasOptions(field: any) {
        return field.optionValues && field.optionValues.length > 0;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/environmentDetails/automation/command-properties/command-properties.component.ts